import {
  GET_PAYROLL_RUN_LIST,
  GET_PAYROLL_RUN_LIST_SUCCESS,
  GET_PAYROLL_RUN_LIST_FAILURE,
  GET_PAYROLL_RUN_DATA,
  GET_PAYROLL_RUN_DATA_SUCCESS,
  GET_PAYROLL_RUN_DATA_FAILURE,
  PAYROLL_CREATE_PREVIEW,
  PAYROLL_CREATE_PREVIEW_SUCCESS,
  PAYROLL_CREATE_PREVIEW_FAILURE,
  PAYROLL_CREATE_PREVIEW_PDF,
  PAYROLL_CREATE_PREVIEW_PDF_SUCCESS,
  PAYROLL_CREATE_PREVIEW_PDF_FAILURE,
  PAYROLL_CREATE,
  PAYROLL_CREATE_SUCCESS,
  PAYROLL_CREATE_FAILURE,
  PAYROLL_UPDATE,
  PAYROLL_UPDATE_SUCCESS,
  PAYROLL_UPDATE_FAILURE,
  PAYROLL_DELETE,
  PAYROLL_DELETE_SUCCESS,
  PAYROLL_DELETE_FAILURE,
  GET_PAYROLL_PAYSLIP_DATA,
  GET_PAYROLL_PAYSLIP_DATA_SUCCESS,
  GET_PAYROLL_PAYSLIP_DATA_FAILURE,
  GET_PAYROLL_PAYSLIP_PDF,
  GET_PAYROLL_PAYSLIP_PDF_SUCCESS,
  GET_PAYROLL_PAYSLIP_PDF_FAILURE,
  GET_PAYROLL_HMRC_LIST,
  GET_PAYROLL_HMRC_LIST_SUCCESS,
  GET_PAYROLL_HMRC_LIST_FAILURE,
  PAYROLL_HMRC_SUBMIT,
  PAYROLL_HMRC_SUBMIT_SUCCESS,
  PAYROLL_HMRC_SUBMIT_FAILURE,
  PAYROLL_HMRC_SETTINGS_SAVE,
  PAYROLL_HMRC_SETTINGS_SAVE_SUCCESS,
  PAYROLL_HMRC_SETTINGS_SAVE_FAILURE,
  GET_PAYROLL_HMRC_SETTINGS_DATA,
  GET_PAYROLL_HMRC_SETTINGS_DATA_SUCCESS,
  GET_PAYROLL_HMRC_SETTINGS_DATA_FAILURE,
  PAYROLL_RESET_RESPONSE,
} from "./actionType";

// ***** List runs *****
export const getPayrollRunList = (TaxYear) => ({
  type: GET_PAYROLL_RUN_LIST,
  payload: TaxYear,
});
export const getPayrollRunListSuccess = (data) => ({
  type: GET_PAYROLL_RUN_LIST_SUCCESS,
  payload: data,
});
export const getPayrollRunListFailure = (error) => ({
  type: GET_PAYROLL_RUN_LIST_FAILURE,
  payload: error,
});

// ***** Run detail *****
export const getPayrollRunData = (PayrollRun_Id) => ({
  type: GET_PAYROLL_RUN_DATA,
  payload: PayrollRun_Id,
});
export const getPayrollRunDataSuccess = (data) => ({
  type: GET_PAYROLL_RUN_DATA_SUCCESS,
  payload: data,
});
export const getPayrollRunDataFailure = (error) => ({
  type: GET_PAYROLL_RUN_DATA_FAILURE,
  payload: error,
});

// ***** Preview a run (no writes) *****
export const payrollCreatePreview = (envelope) => ({
  type: PAYROLL_CREATE_PREVIEW,
  payload: envelope,
});
export const payrollCreatePreviewSuccess = (data) => ({
  type: PAYROLL_CREATE_PREVIEW_SUCCESS,
  payload: data,
});
export const payrollCreatePreviewFailure = (error) => ({
  type: PAYROLL_CREATE_PREVIEW_FAILURE,
  payload: error,
});

// ***** Preview run PDF (first item) *****
export const payrollCreatePreviewPdf = (envelope) => ({
  type: PAYROLL_CREATE_PREVIEW_PDF,
  payload: envelope,
});
export const payrollCreatePreviewPdfSuccess = (data) => ({
  type: PAYROLL_CREATE_PREVIEW_PDF_SUCCESS,
  payload: data,
});
export const payrollCreatePreviewPdfFailure = (error) => ({
  type: PAYROLL_CREATE_PREVIEW_PDF_FAILURE,
  payload: error,
});

// ***** Commit a run *****
export const payrollCreate = (envelope) => ({
  type: PAYROLL_CREATE,
  payload: envelope,
});
export const payrollCreateSuccess = (data) => ({
  type: PAYROLL_CREATE_SUCCESS,
  payload: data,
});
export const payrollCreateFailure = (error) => ({
  type: PAYROLL_CREATE_FAILURE,
  payload: error,
});

// ***** Update a run *****
export const payrollUpdate = (data) => ({
  type: PAYROLL_UPDATE,
  payload: data,
});
export const payrollUpdateSuccess = (data) => ({
  type: PAYROLL_UPDATE_SUCCESS,
  payload: data,
});
export const payrollUpdateFailure = (error) => ({
  type: PAYROLL_UPDATE_FAILURE,
  payload: error,
});

// ***** Delete a run (soft) *****
export const payrollDelete = (data) => ({
  type: PAYROLL_DELETE,
  payload: data,
});
export const payrollDeleteSuccess = (data) => ({
  type: PAYROLL_DELETE_SUCCESS,
  payload: data,
});
export const payrollDeleteFailure = (error) => ({
  type: PAYROLL_DELETE_FAILURE,
  payload: error,
});

// ***** Single payslip data *****
export const getPayrollPayslipData = (PayrollRunItem_Id) => ({
  type: GET_PAYROLL_PAYSLIP_DATA,
  payload: PayrollRunItem_Id,
});
export const getPayrollPayslipDataSuccess = (data) => ({
  type: GET_PAYROLL_PAYSLIP_DATA_SUCCESS,
  payload: data,
});
export const getPayrollPayslipDataFailure = (error) => ({
  type: GET_PAYROLL_PAYSLIP_DATA_FAILURE,
  payload: error,
});

// ***** Single payslip PDF *****
export const getPayrollPayslipPdf = (PayrollRunItem_Id) => ({
  type: GET_PAYROLL_PAYSLIP_PDF,
  payload: PayrollRunItem_Id,
});
export const getPayrollPayslipPdfSuccess = (data) => ({
  type: GET_PAYROLL_PAYSLIP_PDF_SUCCESS,
  payload: data,
});
export const getPayrollPayslipPdfFailure = (error) => ({
  type: GET_PAYROLL_PAYSLIP_PDF_FAILURE,
  payload: error,
});

// ***** HMRC submission history *****
export const getPayrollHmrcList = (PayrollRun_Id) => ({
  type: GET_PAYROLL_HMRC_LIST,
  payload: PayrollRun_Id,
});
export const getPayrollHmrcListSuccess = (data) => ({
  type: GET_PAYROLL_HMRC_LIST_SUCCESS,
  payload: data,
});
export const getPayrollHmrcListFailure = (error) => ({
  type: GET_PAYROLL_HMRC_LIST_FAILURE,
  payload: error,
});

// ***** HMRC retry/submit *****
export const payrollHmrcSubmit = (data) => ({
  type: PAYROLL_HMRC_SUBMIT,
  payload: data,
});
export const payrollHmrcSubmitSuccess = (data) => ({
  type: PAYROLL_HMRC_SUBMIT_SUCCESS,
  payload: data,
});
export const payrollHmrcSubmitFailure = (error) => ({
  type: PAYROLL_HMRC_SUBMIT_FAILURE,
  payload: error,
});

// ***** HMRC employer settings — save *****
export const payrollHmrcSettingsSave = (data) => ({
  type: PAYROLL_HMRC_SETTINGS_SAVE,
  payload: data,
});
export const payrollHmrcSettingsSaveSuccess = (data) => ({
  type: PAYROLL_HMRC_SETTINGS_SAVE_SUCCESS,
  payload: data,
});
export const payrollHmrcSettingsSaveFailure = (error) => ({
  type: PAYROLL_HMRC_SETTINGS_SAVE_FAILURE,
  payload: error,
});

// ***** HMRC employer settings — read *****
export const getPayrollHmrcSettingsData = (TaxYear) => ({
  type: GET_PAYROLL_HMRC_SETTINGS_DATA,
  payload: TaxYear,
});
export const getPayrollHmrcSettingsDataSuccess = (data) => ({
  type: GET_PAYROLL_HMRC_SETTINGS_DATA_SUCCESS,
  payload: data,
});
export const getPayrollHmrcSettingsDataFailure = (error) => ({
  type: GET_PAYROLL_HMRC_SETTINGS_DATA_FAILURE,
  payload: error,
});

// ***** Reset transient responses *****
// keys: array of state keys to reset (e.g. ["payrollCreateResponse"]); omit to reset all transient
export const payrollResetResponse = (keys) => ({
  type: PAYROLL_RESET_RESPONSE,
  payload: keys,
});
